import React, { useCallback, useState } from "react";
import PropTypes from "prop-types";
import { CircularProgress } from "@material-ui/core";
import CircleButton from "../../../app/components/commons/CircleButton";
import { hideModal } from "../../commons/hide-modal";
import { performTopUp } from "../performTopUp";
import { translate } from "../../../infrastructure/translate/localization";

function RecurrentSubsidyModal({ message, model }) {
  const [isLoading, setIsLoading] = useState(false);

  const handleConfirmation = useCallback(async () => {
    setIsLoading(true);
    await performTopUp(model.id);
    window.location.href = "/benefits";
    await hideModal();
    setIsLoading(false);
  }, [model, setIsLoading]);

  return (
    <div className="modal-container">
      <CircleButton
        className="primary close-modal"
        icon="times"
        handlerClick={() => hideModal()}
      />
      <div className="modal-content">
        <div className="modal-left-line" />
        <span className="message">{message}</span>
        <div className="cob-btn-group center-group">
          <button
            type="button"
            className="cob-btn"
            onClick={handleConfirmation}
            disabled={isLoading}
          >
            {isLoading ? (
              <CircularProgress size={12} sx={{ marginRight: "16px" }} />
            ) : (
              translate("actions.confirm")
            )}
          </button>
          <button
            type="button"
            className="cob-btn"
            onClick={() => hideModal()}
            disabled={isLoading}
          >
            {translate("actions.cancel")}
          </button>
        </div>
      </div>
    </div>
  );
}

RecurrentSubsidyModal.defaultProps = {};
RecurrentSubsidyModal.propTypes = {
  message: PropTypes.string.isRequired,
  model: PropTypes.object.isRequired,
};

export default RecurrentSubsidyModal;
